<template>
  <v-dialog
    v-model="show"
    max-width="600"  
    overlay-color="darktext"
    overlay-opacity="0.6"
  >
    <v-card>
      <v-card-title class="pt-6">
        {{ cdTitle }}
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
          @keyup.enter="submitDialogBtn()"
          @submit.prevent
        >
         
          <v-select
            v-model="selectedItem"
            background-color="background"
            data-testid="items-select"
            class="rounded-xl select-items mt-5" 
            :items="categories" 
            item-text="attributes.title"
            item-value="id"
            return-object 
            solo
            hide-details="true"
            append-icon="mdi-chevron-down"
            dense
            :menu-props="{
              closeOnContentClick:true,
              rounded: 'xxl',
              maxHeight:260,
              maxWidth: 560,
              contentClass: 'mt-n1'
            }"
          >
            <!-- eslint-disable-next-line -->
            <template v-slot:item="{item}">
              <span> {{ item.attributes.title }}</span>
            </template>
          </v-select>
          <v-card-actions class="mt-15">
            <v-spacer />
            <v-btn
              ref="cancel"
              data-testid="cancel-button"
              color="darktext"
              min-width="100"
              dark
              elevation="0"
              class="rounded-xl text-none px-4"
              @click="show=false"
            >
              {{ cdCancelBtn }}
            </v-btn>
            <v-btn
              ref="submit"
              data-testid="submit-button"
              type="submit"
              color="accent"
              min-width="100"
              dark
              elevation="0"
              class="rounded-xl text-none px-4"
              :loading="loading"
              @click="submitDialogBtn()"
            >
              {{ cdSubmitBtn }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import i18n from '../plugins/i18n';

export default {
  props: {
    visible: Boolean,
    cdTitle: {
      type: String,
      default: ''
    },
    cdSubmitBtn: {
      type: String,
      default: ''
    },
    cdCancelBtn: {
      type: String,
      default: ''
    },
    item: {
      type: Object,
      default: () => {}
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  data(){
        return{
          valid: true,
          alertMsg: '',
          selectedItem: {"id": "none", "attributes": {"title": i18n.t("none"), "entity_id" : null}},
          loading: false,
          categories: []
         }
    },
  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close')
          this.$refs.form.reset()
        }
      }
    }
  },
  created(){
      this.categories = JSON.parse(JSON.stringify(this.items))
      this.categories.unshift({"id": "none", "attributes": {"title": i18n.t("none"), "entity_id" : null}});
      if(this.item.attributes.category_id != null){
        this.selectedItem = this.categories[this.categories.findIndex(item => item.id == this.item.meta.parent_feed_item_id)]
      }  
  },
  methods: {
    submitDialogBtn() {
      this.valid = this.$refs.form.validate()
      if(this.valid){
        this.loading = true
        this.$emit('proceedSubmit', this.item, this.selectedItem.attributes.entity_id)
        this.$refs.form.reset()
      }
    },
  },
}
</script>
<style scope>
.set-rule-menu .v-select-list {
  background: var(--v-background-base);
}
</style>